import React, { useEffect, useState } from "react";
import axios from "axios";
import URL from "../config/API";

function Wallet() {
  const [balance, setBalance] = useState(0);
  const [transactions, setTransactions] = useState([]);
  const token = localStorage.getItem("token");

  useEffect(() => {
    fetchWallet();
  }, []);

  const fetchWallet = async () => {
    try {
      const res = await axios.get(`${URL.BASE_URL}/wallet`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setBalance(res.data.balance);
      setTransactions(res.data.transactions);
    } catch (error) {
      console.error("Wallet fetch error:", error);
    }
  };

  return (
    <div className="container mt-4">
      <h2>💰 My Wallet</h2>

      {/* BALANCE CARD */}
      <div className="wallet-card">
        <h4>Available Balance</h4>
        <h1>₹ {balance}</h1>
      </div>

      {/* TRANSACTION HISTORY */}
      <div className="wallet-history mt-4">
        <h4>Transaction History</h4>

        {transactions.length === 0 ? (
          <p>No transactions found</p>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Type</th>
                <th>Amount</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {transactions.map((item, index) => (
                <tr key={index}>
                  <td>{new Date(item.createdAt).toLocaleDateString()}</td>
                  <td>{item.type}</td>
                  <td>₹ {item.amount}</td>
                  <td>{item.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default Wallet;
